// extracted by mini-css-extract-plugin
module.exports = {"backgroundCss":"CurrentAccountIndicator_backgroundCss__9Qbkm","foregroundCss":"CurrentAccountIndicator_foregroundCss__erg8E"};